module.exports = __webpack_public_path__ + "static/media/Grand.80742482.jpeg";